<div class="content mt-2 mb-3">
  <app-datatable
    [dataSource]="lightTagSource"
    [columns]="columns"
    [customActions]="statusActions"
    [compactPortraitColumnCount]="2"
    [compactPortraitColumns]="compactPortraitColumns"
    [identifier]="'lighttag'"
    [actionNew]="false"
    (showEvent)="show($event.valueOf())"
  >
    <app-empty-table
      [icon]="'devices'"
      [emptyText]="'lighttag.empty_text' | translate"
    >
    </app-empty-table>
  </app-datatable>
  <ng-template #statusCell let-device>
    <app-device-status-badge
      [status]="device.status"
      [managerView]="isManager"
      translationKeyPrefix="lighttag.statusValues"
    ></app-device-status-badge>
  </ng-template>
  <ng-template #batteryPredictionCell let-device>
    <app-battery-prediction-badge
      [prediction]="device.batteryPrediction"
    ></app-battery-prediction-badge>
  </ng-template>
  <app-error [error]="error"></app-error>
</div>
